import { Endeavour } from './Endeavour';
import { ResourceAttributes } from './OpenTelemetry/Resources';
import { ResourceFB } from './Protocol/EndeavourProtocol';
import { ProtocolUtils } from './ProtocolUtils';

export class ResourceModel {
  public buildResource(builder: flatbuffers.Builder): number {
    const resourceAttributes: ResourceAttributes = Endeavour.getResources().attributes;
    const standardAttributeIndexes: flatbuffers.Offset[] = ProtocolUtils.createStandardAttributeIndexes(builder, resourceAttributes);
    const standardPropertiesOffset: flatbuffers.Offset = ResourceFB.createStandardAttributesVector(builder, standardAttributeIndexes);
    return ResourceFB.createResource(builder, standardPropertiesOffset, 0);
  }
}
